module.exports = __webpack_public_path__ + "static/media/DetailsHealthcareSolutionCarepatch3.4c221d90.png";